import { render, staticRenderFns } from "./BtnAtualizarManutencao.vue?vue&type=template&id=1b9c4e11&"
import script from "./BtnAtualizarManutencao.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarManutencao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports